import { render, staticRenderFns } from "./wtr-case-card.vue?vue&type=template&id=238998bc&scoped=true&"
import script from "./wtr-case-card.vue?vue&type=script&lang=js&"
export * from "./wtr-case-card.vue?vue&type=script&lang=js&"
import style0 from "./wtr-case-card.vue?vue&type=style&index=0&id=238998bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238998bc",
  null
  
)

export default component.exports